<template>
    <main>
        <SubredditsWidget :dialog="displayData" area="a"/>
        <UserDataWidget area="b"/>
        <LinkDataWidget area="c" :dialog="displayData"/>
        <CommentDataWidget area="d" :dialog="displayData"/>
        <CalendarWidget :dialog="displayData" area="e"/>
        <ActivityHoursWidget area="f"/>
        <KarmaDataWidget area="g"/>
        <SubmissionsWidget :dialog="displayData" area="h"/>
        <FlairsWidget area="i"/>
        <NsfwWidget :dialog="displayData" area="l"/>
        <WordDataWidget area="m"/>
        <GuessWidget area="n"/>

        <el-dialog class="data-dialog" :title="dialogTitle" :visible.sync="dataDialogVisible">
            <DialogList :posts="dialogData"/>
        </el-dialog>
    </main>
</template>

<script>
    import SubredditsWidget from "../components/widgets/SubredditsWidget";
    import {mapGetters} from "vuex";
    import UserDataWidget from "../components/widgets/UserDataWidget";
    import CalendarWidget from "../components/widgets/CalendarWidget";
    import LinkDataWidget from "../components/widgets/LinkDataWidget";
    import CommentDataWidget from "../components/widgets/CommentDataWidget";
    import ActivityHoursWidget from "../components/widgets/ActivityHoursWidget";
    import KarmaDataWidget from "../components/widgets/KarmaDataWidget";
    import SubmissionsWidget from "../components/widgets/SubmissionsWidget";
    import FlairsWidget from "../components/widgets/FlairsWidget";
    import NsfwWidget from "../components/widgets/NsfwWidget";
    import WordDataWidget from "../components/widgets/WordDataWidget";
    import GuessWidget from "../components/widgets/GuessWidget";
    import DialogList from "../components/dialog/DialogList";

    export default {
        components: {
            DialogList,
            GuessWidget,
            WordDataWidget,
            NsfwWidget,
            FlairsWidget,
            SubmissionsWidget,
            KarmaDataWidget,
            ActivityHoursWidget,
            CommentDataWidget,
            LinkDataWidget,
            CalendarWidget,
            UserDataWidget,
            SubredditsWidget
        },
        data() {
            return {dataDialogVisible: false, dialogData: [], dialogTitle: ''}
        },
        computed: {
            ...mapGetters(['user'])
        },
        methods: {
            displayData(title, data) {
                this.dataDialogVisible = true;
                this.dialogData = data;
                this.dialogTitle = title;
            }
        },
        mounted() {
            if (this.user === null && !empty(this.$route.params.user)){
                this.$router.replace('/search/' + this.$route.params.user);
            }
        },
        created() {
            // if (this.user === null)
            //     this.$router.push('');
        }
    }
</script>

<style lang="scss">
    .data-dialog {
        .el-dialog {
            width: 90%;
        }
    }
</style>
<style scoped>
    main {
        grid-column: 2;
        grid-row: 2 / 5;

        display: grid;
        grid-gap: 1em;
        grid-template: "a b c d" 250px "a g f f" 350px "e e e e" 240px "h i i m" 250px "h l n n" 250px;
        grid-auto-columns: 1fr;

        max-width: 1100px;
        width: 100%;
        margin: 50px auto;
    }

    @media only screen and (max-width: 900px) {
        main {
            width: calc(100% - 2em);
            padding: 0 1em;
            grid-template: "a b" 250px "a g" 340px "d c" 250px "f m" 250px "e e" 240px "h i" 250px "l n" 250px;
        }
    }

    @media only screen and (max-width: 500px) {
        main {
            width: calc(100% - 2em);
            padding: 0 1em;
            grid-template: "a" 600px "b" 220px "c" 220px "d" 250px "e" 240px "f" 250px "g" 350px "h" 400px "i" 250px "l" 250px "m" 200px "n" 200px;
        }
    }

</style>
